import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

interface ComingSoonPanelProps {
  icon: LucideIcon;
  title: string;
  description: string;
  mobileTitle?: string;
  mobileDescription?: string;
  className?: string;
}

function ResponsiveCopy({ mobile, desktop }: { mobile?: string; desktop: string }): ReactNode {
  if (!mobile) {
    return desktop;
  }

  return (
    <>
      <span className="md:hidden">{mobile}</span>
      <span className="hidden md:inline">{desktop}</span>
    </>
  );
}

function ComingSoonPanel({
  icon: Icon,
  title,
  description,
  mobileTitle,
  mobileDescription,
  className,
}: ComingSoonPanelProps) {
  return (
    <div
      className={cn(
        "coming-soon-panel mx-auto max-w-[480px] rounded-2xl border border-dashed border-pro-border bg-pro-card px-8 py-12 text-center",
        className,
      )}
    >
      <div className="icon mx-auto mb-5 flex size-14 items-center justify-center rounded-2xl bg-lime-subtle max-md:size-12 max-md:rounded-[14px]">
        <Icon className="size-7 text-lime-text max-md:size-6" strokeWidth={1.8} aria-hidden />
      </div>
      <h2
        className={cn(
          "text-[20px] font-bold tracking-tight text-pro-text",
          mobileTitle && "max-md:text-[18px]",
        )}
      >
        <ResponsiveCopy mobile={mobileTitle} desktop={title} />
      </h2>
      <p
        className={cn(
          "mx-auto mt-2 max-w-[360px] text-[14px] leading-relaxed text-pro-text-muted",
          mobileDescription && "max-md:text-[13px]",
        )}
      >
        <ResponsiveCopy mobile={mobileDescription} desktop={description} />
      </p>
    </div>
  );
}

export { ComingSoonPanel, type ComingSoonPanelProps };
